jQuery(document).ready(function(){

    if(jQuery('.flavor_select').length > 0)
    {
        jQuery('.flavor_select').on('change',function()
        {
            var selectedOption = jQuery('option:selected',this).val();
            console.log(selectedOption);
            if(selectedOption)
            {
                jQuery('.product-form__input input[value="'+selectedOption+'"]').trigger("click");
            }
        });
    }
    if(jQuery('body.product .product__media-list li').length > 1)
    {
      jQuery('.prod_image .btns').show();
    }
    jQuery('.product-form__input label').on('click',function(){
        jQuery(this).closest('.product-form__input').find('label').each(function()
        {
            jQuery(this).removeClass('selectedOption');
        });
        jQuery(this).addClass('selectedOption');
    });

    jQuery('variant-radios label').on('click',function(){
       setTimeout(function()
          {
            jQuery('.product-form__submit').prop('disabled',false);
            var selectedVariant = window.location.search.split('variant=')[1];
            var selectedVariantImg = jQuery('#vimg-'+selectedVariant).val();
            console.log(selectedVariant);
            console.log(selectedVariantImg);
            jQuery('ul.product__media-list li.product__media-item').removeClass('is-active');
            jQuery('ul.product__media-list li.product__media-item').first().find('.product__media img').attr('src',selectedVariantImg).attr('srcset','');
            jQuery('ul.product__media-list li.product__media-item').first().addClass('is-active');
          },500);
    });
    jQuery('.marquee-with-options').marquee({
    	speed: 50000,
    	gap: 50,
    	delayBeforeStart: 0,
    	direction: 'left',
    	duplicated: true,
    	pauseOnHover: true
    });    


});